import React from 'react';

interface HoneypotProps {
  value: string;
  onChange: (value: string) => void;
}

/**
 * Bot trap: hidden from real users (and from screen readers), submitted with every
 * payload. A non-empty value is rejected server-side.
 */
const Honeypot: React.FC<HoneypotProps> = ({ value, onChange }) => (
  <div className="absolute -left-[9999px] top-auto h-px w-px overflow-hidden" aria-hidden="true">
    <label htmlFor="bookDemoWebsite">Website</label>
    <input
      id="bookDemoWebsite"
      name="website"
      type="text"
      tabIndex={-1}
      autoComplete="off"
      value={value}
      onChange={e => onChange(e.target.value)}
    />
  </div>
);

export default Honeypot;
